const initialState = {
  totalItems: 0,
  width: 1280,
  previousCart: [],
};

const actions = {
  SET_TOTAL_QTY: 'myCart/SET_TOTAL_QTY',
  SET_DEVICE_WIDTH: 'myCart/SET_DEVICE_WIDTH',
  SET_PREVIOUS_CART: 'myCart/SET_PREVIOUS_CART',
};

export const MyCartReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }
  if (action.type === actions.SET_TOTAL_QTY) {
    return {
      ...state,
      totalItems: action.payload,
    };
  }
  if (action.type === actions.SET_DEVICE_WIDTH) {
    return {
      ...state,
      width: action.payload,
    };
  }
  if (action.type === actions.SET_PREVIOUS_CART) {
    return { ...state, previousCart: action.payload };
  }
  return state;
};

export const setTotalQtyData = (totalItems) => ({
  type: actions.SET_TOTAL_QTY,
  payload: totalItems,
});

export const setDeviceWidth = (width) => ({
  type: actions.SET_DEVICE_WIDTH,
  payload: width,
});

export const setPreviousCart = (previousCart) => ({
  type: actions.SET_PREVIOUS_CART,
  payload: previousCart,
});

export default MyCartReducer;
